import yup from 'utils/yup';

export const initialEmployeeReportsFormData = {
  date_range: [null, null] as any,
  user_id: null as any,
  group_id: null as any,
  timesheet_ids: [],
};

export const employeeReportsDateRangeValidationSchemaForEmployeeOnly = yup.object().shape({
  date_range: yup.array().of(yup.string().min(2)).required(),
});

export const employeeReportsDateRangeValidationSchema = yup.object().shape(
  {
    date_range: yup.array().of(yup.string().min(2, 'This is required').required()),
    user_id: yup.string().when('group_id', {
      is: '',
      then: yup.string().required(),
      otherwise: yup.string(),
    }),
    group_id: yup.string().when('user_id', {
      is: '',
      then: yup.string().required(),
      otherwise: yup.string(),
    }),
  },
  [['user_id', 'group_id']]
);
